import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ACL_SITE_EDIT, AuthService } from '@shared/services/auth.service';
import { Menu, MenuItem } from '@shared/services/menu.service';
import {
  ADD_ORGANIZATION_ROUTE,
  ADD_ROUTE,
  DASHBOARD_ROUTE,
  MFA_VALIDATION,
  MY_ORGANIZATION_ROUTE,
  MY_PROFILE_ROUTE,
  MY_SITES_ROUTE,
} from 'app/app-routing.constants';
import { Lang } from '@shared/utils/lang';
import { UnsavedChangesService } from '@shared/services/unsaved-state/unsaved-changes.service';
import { DirtyStateService } from '@shared/services/dirty-state/dirty-state.service';
import { ClickOutsideModule } from 'ng-click-outside';
import { NgClass, NgFor, NgIf } from '@angular/common';
import {
  AccordionAnchorDirective,
  AccordionDirective,
  AccordionLinkDirective,
} from '@shared/directives/accordion-directives';
import { AccessDirective } from '@shared/directives/access.directive';
import { LabelBetaComponent } from '@shared/components/label-beta/label-beta.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  providers: [TranslateService, Title],
  animations: [
    trigger('notificationBottom', [
      state(
        'an-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        }),
      ),
      state(
        'an-animate',
        style({
          'overflow-y': 'scroll',
          height: AUTO_STYLE,
          maxHeight: '80vh',
        }),
      ),
      transition('an-off <=> an-animate', [animate('400ms ease-in-out')]),
    ]),
    trigger('docNotif', [
      state(
        'an-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        }),
      ),
      state(
        'an-animate',
        style({
          overflow: 'hidden',
          height: AUTO_STYLE,
        }),
      ),
      transition('an-off <=> an-animate', [animate('400ms ease-in-out')]),
    ]),
    trigger('slideInOut', [
      state(
        'in',
        style({
          width: '300px',
          // transform: 'translate3d(0, 0, 0)'
        }),
      ),
      state(
        'out',
        style({
          width: '0',
          // transform: 'translate3d(100%, 0, 0)'
        }),
      ),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ]),
    trigger('mobileHeaderNavRight', [
      state(
        'nav-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        }),
      ),
      state(
        'nav-on',
        style({
          height: AUTO_STYLE,
        }),
      ),
      transition('nav-off <=> nav-on', [animate('400ms ease-in-out')]),
    ]),
    trigger('fadeInOutTranslate', [
      transition(':enter', [style({ opacity: 0 }), animate('400ms ease-in-out', style({ opacity: 1 }))]),
      transition(':leave', [style({ transform: 'translate(0)' }), animate('400ms ease-in-out', style({ opacity: 0 }))]),
    ]),
  ],
  imports: [
    ClickOutsideModule,
    RouterLink,
    NgIf,
    NgClass,
    NgFor,
    AccordionDirective,
    AccordionLinkDirective,
    RouterLinkActive,
    AccessDirective,
    AccordionAnchorDirective,
    LabelBetaComponent,
    RouterOutlet,
    TranslatePipe,
  ],
})
export class LayoutComponent implements OnInit, AfterViewChecked {
  lang: string;

  /* CSS & HTML Stuff */
  navType: string;
  themeLayout: string;
  verticalPlacement: string;
  verticalLayout: string;
  pcodedDeviceType: string;
  verticalNavType: string;
  verticalEffect: string;
  vnavigationView: string;
  sidebarImg: string;
  sidebarImgType: string;
  layoutType: string;
  headerTheme: string;
  pcodedHeaderPosition: string;
  liveNotification: string;
  liveNotificationClass: string;
  profileNotification: string;
  profileNotificationClass: string;
  changeOrganization: string;
  changeOrganizationnizationClass: string;
  navRight: string;
  windowWidth: number;
  chatTopPosition: string;
  toggleOn: boolean;
  navBarTheme: string;
  activeItemTheme: string;
  pcodedSidebarPosition: string;
  dropDownIcon: string;
  subItemIcon: string;
  displayBoxLayout: string;
  isVerticalLayoutChecked: boolean;
  isSidebarChecked: boolean;
  isHeaderChecked: boolean;
  headerFixedMargin: string;
  sidebarFixedHeight: string;
  itemBorderStyle: string;
  subItemBorder: boolean;
  itemBorder: boolean;
  titre: any;
  /* End of CSS & HTML Stuff */

  MY_ORGANIZATION_ROUTE = MY_ORGANIZATION_ROUTE;
  MY_PROFILE_ROUTE = MY_PROFILE_ROUTE;
  ADD_ORGANIZATION_ROUTE = ADD_ORGANIZATION_ROUTE;
  DASHBOARD_ROUTE = DASHBOARD_ROUTE;
  ACL_SITE_EDIT = ACL_SITE_EDIT;
  hideAddDomain: boolean;

  menuItems: MenuItem[];

  protected readonly userFeatures = new Set(this.auth.user.features);

  constructor(
    menu: Menu,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService,
    private dirtyState: DirtyStateService,
    private unsavedChanges: UnsavedChangesService,
  ) {
    // Init last action date
    // For decconection feature
    sessionStorage.setItem('lastAction', Date.now().toString());

    this.menuItems = menu.getAll();

    this.navType = 'st2';
    this.themeLayout = 'vertical';
    this.verticalPlacement = 'left';
    this.verticalLayout = 'wide';
    this.pcodedDeviceType = 'desktop';
    this.verticalNavType = 'expanded';
    this.verticalEffect = 'shrink';
    this.vnavigationView = 'view1';
    this.sidebarImg = 'false';
    this.sidebarImgType = 'img1';
    this.layoutType = 'light';

    this.headerTheme = 'primary';
    this.pcodedHeaderPosition = 'fixed';

    this.liveNotification = 'an-off';
    this.profileNotification = 'an-off';
    this.changeOrganization = 'an-off';

    this.navRight = 'nav-on';

    this.hideAddDomain = false;

    this.windowWidth = window.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    this.toggleOn = true;
    this.navBarTheme = 'dark';
    this.activeItemTheme = 'primary';
    this.pcodedSidebarPosition = 'fixed';
    this.dropDownIcon = 'style3';
    this.subItemIcon = 'style6';

    this.displayBoxLayout = 'd-none';
    this.isVerticalLayoutChecked = false;
    this.isSidebarChecked = true;
    this.isHeaderChecked = true;
    this.headerFixedMargin = '56px';
    this.sidebarFixedHeight = 'calc(100vh - 56px)';
    this.itemBorderStyle = 'none';
    this.subItemBorder = true;
    this.itemBorder = true;

    this.setMenuAttributes(this.windowWidth);
    this.setHeaderAttributes(this.windowWidth);

    this.router.events.subscribe((e: NavigationEnd) => {
      if (e instanceof NavigationEnd) {
        this.hideAddDomain = e.url.startsWith('/' + MY_SITES_ROUTE);
      }

      let currentRoute = this.route.root;
      let title = '';
      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach((routes) => {
          if (routes.outlet === 'primary') {
            title = routes.snapshot.data.title;
            currentRoute = routes;
          }
        });
      } while (currentRoute);
      if (title !== undefined) {
        this.titre = title;
      }
    });
  }

  ngOnInit() {
    this.lang = this.auth.getCurrentLanguage();
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  async changeCurrentOrganization(organizationCode: string) {
    if (this.dirtyState.isDirty()) {
      const confirmed = await this.unsavedChanges.confirm();
      if (!confirmed) return;
      this.dirtyState.clear();
    }

    this.auth.changeCurrentOrganization(organizationCode);
  }

  async changeLang(lang: Lang) {
    if (this.auth.getCurrentLanguage() === lang) return;

    if (this.dirtyState.isDirty()) {
      const confirmed = await this.unsavedChanges.confirm();
      if (!confirmed) return;
      this.dirtyState.clear();
    }

    this.auth.updateUser({ lang });
    location.reload();
  }

  logout() {
    this.auth.logout();
  }

  goToDocumentation() {
    window.open(this.translate.instant('ExternalHelp.root'), '_blank');
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    let reSizeFlag = true;
    if (this.pcodedDeviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.pcodedDeviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.windowWidth);
    }
  }

  setHeaderAttributes(windowWidth) {
    if (windowWidth < 992) {
      this.navRight = 'nav-off';
    } else {
      this.navRight = 'nav-on';
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.pcodedDeviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else if (windowWidth < 768) {
      this.pcodedDeviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.pcodedDeviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  toggleHeaderNavRight() {
    this.navRight = this.navRight === 'nav-on' ? 'nav-off' : 'nav-on';
    this.chatTopPosition = this.chatTopPosition === 'nav-on' ? '112px' : '';
  }

  toggleLiveNotification() {
    this.liveNotification = this.liveNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.liveNotificationClass = this.liveNotification === 'an-animate' ? 'active' : '';
  }

  toggleProfileNotification() {
    this.profileNotification = this.profileNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.profileNotificationClass = this.profileNotification === 'an-animate' ? 'active' : '';
  }

  async toggleChangeOrganization() {
    this.changeOrganization = this.changeOrganization === 'an-off' ? 'an-animate' : 'an-off';
    this.changeOrganizationnizationClass = this.changeOrganization === 'an-animate' ? 'active' : '';
  }

  notificationOutsideClick(ele: string) {
    if (ele === 'live' && this.liveNotification === 'an-animate') {
      this.toggleLiveNotification();
    } else if (ele === 'profile' && this.profileNotification === 'an-animate') {
      this.toggleProfileNotification();
    } else if (ele === 'organization' && this.changeOrganization === 'an-animate') {
      this.toggleChangeOrganization();
    }
  }

  toggleOpened() {
    this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
    if (this.windowWidth < 992 && this.navRight === 'nav-on') {
      this.toggleHeaderNavRight();
    }
    this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
  }

  onClickedOutsideSidebar(e: Event) {
    if (
      (this.windowWidth < 992 && this.toggleOn && this.verticalNavType !== 'offcanvas') ||
      this.verticalEffect === 'overlay'
    ) {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }

  protected readonly MY_SITES_ROUTE = MY_SITES_ROUTE;
  protected readonly ADD_ROUTE = ADD_ROUTE;
  protected readonly MFA_VALIDATION = MFA_VALIDATION;
  protected readonly AuthService = AuthService;
}
